import { useState, useEffect, useCallback } from 'react';
import { Bell } from 'lucide-react';
import { api } from '@/lib/api';
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';

export const NotificationBell = () => {
  const [data, setData] = useState({ notifications: [], unread: 0 });

  const load = useCallback(async () => {
    try { const r = await api.get('/notifications'); setData(r.data); } catch (e) { /* ignore */ }
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, [load]);

  const markAll = async () => { await api.post('/notifications/read-all'); load(); };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="relative p-2 hover:bg-forest/5 rounded-full transition-colors" data-testid="notification-bell">
          <Bell className="w-5 h-5 text-dark" />
          {data.unread > 0 && (
            <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 bg-gold text-dark text-[10px] font-bold rounded-full flex items-center justify-center" data-testid="notification-count">{data.unread}</span>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80 bg-white border border-forest/10 p-0 max-h-96 overflow-auto">
        <div className="flex items-center justify-between px-4 py-3 border-b border-forest/10 sticky top-0 bg-white">
          <span className="font-playfair font-bold text-dark">Notifications</span>
          {data.unread > 0 && <button onClick={markAll} className="text-xs text-forest font-medium hover:underline" data-testid="mark-all-read">Mark all read</button>}
        </div>
        {data.notifications.length === 0 ? (
          <p className="px-4 py-8 text-center text-dark/50 font-manrope text-sm">No notifications yet</p>
        ) : (
          data.notifications.slice(0, 20).map((n) => (
            <div key={n.notification_id} className={`px-4 py-3 border-b border-forest/5 ${!n.read ? 'bg-forest/5' : ''}`} data-testid={`notification-${n.type}`}>
              <p className="font-manrope font-semibold text-dark text-sm">{n.title}</p>
              <p className="font-manrope text-dark/60 text-xs mt-0.5">{n.body}</p>
              <p className="font-manrope text-dark/40 text-[10px] mt-1">{new Date(n.created_at).toLocaleString()}</p>
            </div>
          ))
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
